export default __webpack_public_path__ + "static/NUSL_ARI_logo-853fa21378bd62b1ee56ea6b1fd9b448.png";